import { fromJS } from 'immutable';
import * as microsoftActions from '../actions/microsoft';
import { SUCCESS, START, ERROR } from '@modules/appraisal/actions/global';
import { fetchingState } from '@constants';

const initialState = {
  conferences: {
    data: [],
    state: null,
  },
};

export default (state = fromJS(initialState), { type, data }) => {
  switch (type) {
    case microsoftActions.FETCH_CONFERENCES[START]:
      return state.setIn(['conferences', 'state'], fetchingState.FETCHING);

    case microsoftActions.FETCH_CONFERENCES[SUCCESS]:
      return state
        .setIn(['conferences', 'state'], fetchingState.LOADED)
        .setIn(['conferences', 'data'], fromJS(data ? data.results : []));
    case microsoftActions.FETCH_CONFERENCES[ERROR]:
      return state.setIn(['conferences', 'state'], fetchingState.ERROR);

    default:
      return state;
  }
};
